import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFinderFace: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFinderFace"><Path d="M7.5 7V10" stroke="currentColor"/><Path d="M16.5 7V10" stroke="currentColor"/><Path d="M14 2C12.16 5.87015 10.8443 8.79922 10 13H13C12.4417 16.0502 12.4417 18.9498 13 22" stroke="currentColor"/><Path d="M4.5 16C9.62358 19.5635 14.3764 19.5635 19.5 16" stroke="currentColor"/></CentralIconBase>;
});

export default IconFinderFace;
